module.exports = __webpack_public_path__ + "static/img/canvasDefault.d90d1526.png";